import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { getHelpText } from '../utils/help-content';
import { isSmallUI } from 'shared/app/lib/choose-ui-type';
import { ClickAwayListener, IconButton, Paper, Popper } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';
import { MessageBox } from 'shared/components/dialogs/message-box';
import { useAnchor } from 'shared/hooks/utils';
export const TooltipWithPopUp = memo(function TooltipWithPopUp(props) {
    const { title, anchorEl, onClose, border_color } = props;
    const open = Boolean(anchorEl);
    if (isSmallUI()) {
        return (_jsx(MessageBox, { open: open, onClose: onClose, closeButtonTitle: "\u041E\u041A", border_color: border_color, children: title }));
    }
    return (_jsx(Popper, { sx: { zIndex: 1500 }, open: open, anchorEl: anchorEl, placement: "top", children: _jsx(ClickAwayListener, { onClickAway: onClose, children: _jsx(Paper, { sx: {
                    p: 2,
                    fontSize: 16,
                    maxWidth: 350,
                    whiteSpace: 'pre-line',
                }, elevation: 3, children: title }) }) }));
});
export const MaterialHelpPopUp = memo(function MaterialHelpPopUp(props) {
    const { help_id, help_options, anchorEl, onClickAway } = props;
    const content = getHelpText(help_id, help_options ?? null);
    return (_jsx(TooltipWithPopUp, { anchorEl: anchorEl, onClose: onClickAway, title: (content && content.text.trim()) || help_id }));
});
export const MaterialHelpPopupUncontrolled = memo(function MaterialHelpPopupUncontrolled(props) {
    const { help_id, help_options } = props;
    const [anchorEl, open, close] = useAnchor();
    const show_help_icon = help_id !== null && getHelpText(help_id, help_options ?? null) !== null;
    const highlight_help_icon = help_id !== null && getHelpText(help_id, help_options ?? null)?.isAssigned;
    return (_jsxs(_Fragment, { children: [show_help_icon ? (_jsx(IconButton, { size: "small", edge: "end", onClick: open, children: _jsx(HelpOutline, { fontSize: "small", color: highlight_help_icon ? 'inherit' : 'error' }) })) : null, help_id && (_jsx(MaterialHelpPopUp, { help_id: help_id, help_options: help_options, anchorEl: anchorEl, onClickAway: close }))] }));
});
